import { THIRD_PARTY_PRIVACY_TERMS_HISTORY } from 'constant/npay/ThirdPartyPrivacyTerms';
import AppTermsFrame from '../AppTermsFrame';

const NPayThirdPartyPrivacyTerms = () => {
  return (
    <AppTermsFrame
      title="[필수] 개인정보 제3자 제공 동의"
      url="/npay/third-party-privacy-terms"
      historyData={THIRD_PARTY_PRIVACY_TERMS_HISTORY}
    />
  );
};

export default NPayThirdPartyPrivacyTerms;
